import { motion } from "framer-motion";
import "../../asstes/styles/conditionEngagement.scss";
import ConditionsBanner from "../../asstes/images/private-council/WhoSeeks-2.jpg"; 
const PrivateCouncilConditionEngagement = () => {
    return (
        <section className="condition-engagement-section">

            <div className="gradient-orb orb-left"></div>
            <div className="gradient-orb orb-right"></div>

            <div className="container">

                <motion.div
                    initial={{ opacity: 0, y: 60 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1 }}
                    viewport={{ once: true }}
                    className="heading-area"
                >

                    <span className="section-tag">
                        CONDITIONS OF ALIGNMENT
                    </span>

                    <h2 className="main-title">
                        Condition of <span>Engagement</span>
                    </h2>

                </motion.div>

                <div className="row align-items-center g-5">

                    {/* IMAGE BLOCK */}
                    <div className="col-lg-5">
                        <motion.div
                            initial={{ opacity: 0, x: -80, scale: 0.8 }}
                            whileInView={{ opacity: 1, x: 0, scale: 1 }}
                            transition={{ duration: 1 }}
                            viewport={{ once: true }}
                            className="image-block"
                        >

                            {/* <div className="image-overlay"></div> */}

                            <img
                                src={ConditionsBanner}
                                alt="Luxury Space"
                                className="main-image"
                            />

                            

                        </motion.div>
                    </div>

                    {/* CONTENT BLOCK */}
                    <div className="col-lg-7">

                        <motion.div
                            initial={{ opacity: 0, x: 80 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 1 }}
                            viewport={{ once: true }}
                            className="content-card"
                        >

                            <div className="top-line"></div>

                            <p className="main-description">
                                A commitment must exist to engage in the
                                convening without the ability to recommend
                                the sessions to others who haven't come.
                            </p>

                            <div className="divider-line"></div>

                            <p className="sub-description">
                                It is a threshold condition that must
                                be met before the Council is formed.
                            </p>

                            <motion.div
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 1, delay: 0.4 }}
                                viewport={{ once: true }}
                                className="quote-box"
                            >
                                Hesitation, negotiation, or justification
                                indicates misalignment. In such cases,
                                the Council is not convened.
                            </motion.div>

                        </motion.div>

                    </div>

                </div>

            </div>
        </section>
    );
};

export default PrivateCouncilConditionEngagement;